import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from 'rxjs';
import { map, switchMap, catchError } from "rxjs/operators";

import {
  UPDATE_PHYSICAL_ORGANISATION,
  UPDATE_PHYSICAL_ORGANISATION_SUCCESS,
  UPDATE_PHYSICAL_ORGANISATION_FAIL
} from "../../constants";

import {
  toastSuccess,
  toastpending,
  toastFail
} from "../../../utilities/epic-helpers";
let toastId = "";

const updatePhysicalOrganization = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_PHYSICAL_ORGANISATION),
    switchMap(action => {
      toastId = toastpending(
        "Updating physical organisation...",
        "updatePhysicalOrganisation"
      );

      return (
        ajax({
          url: `${state$.value.auth.server}/admin/organizations/${action.clientId}`,
          headers: {
            Authorization: `Bearer ${state$.value.auth.LIPToken}`,
            "Content-Type": "application/json"
          },
          responseType: "json",
          crossDomain: true,
          body: action.data,
          method: "PATCH"
        }).pipe(
          map(response => {
            toastSuccess("Updated Success", toastId);
            return {
              type: UPDATE_PHYSICAL_ORGANISATION_SUCCESS,
              data: response.response
            };
          }),
          catchError(error =>{
            toastFail(error.response.message, toastId);
            return of({
              type: UPDATE_PHYSICAL_ORGANISATION_FAIL,
              message: error.response.message
            })
          })
        )
      );
    })
  );

export default updatePhysicalOrganization;

